import React from "react";
import { Navigate, useLocation } from "react-router";
import PropTypes from "prop-types";
import useAuth from "../hooks/useAuth";
import { usePermissions } from "src/contexts/permissions";
import { getReturnToFromLocation } from "../utils/authReturnTo";
import { ADMINISTRATE_PATH, isAdministrateWorkspace } from "../utils/workspaceDisplay";

const GuestGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const { can } = usePermissions();
  const location = useLocation();

  if (isAuthenticated) {
    const returnTo = getReturnToFromLocation(location);

    if (returnTo === ADMINISTRATE_PATH || returnTo?.startsWith(`${ADMINISTRATE_PATH}/`)) {
      window.location.replace(returnTo);
      return null;
    }

    if (returnTo && returnTo !== "/") {
      return <Navigate to={returnTo} replace />;
    }

    if (isAdministrateWorkspace(user.company) && user.role === "super_admin") {
      window.location.replace(ADMINISTRATE_PATH);
      return null;
    }

    const isGuest = user.role === "guest";

    if (can("pages.dashboard")) {
      return <Navigate to="/dashboard" replace />;
    }

    if ((can("pages.shopping") || can("pages.shopping_cart")) && !isGuest) {
      return <Navigate to="/shopping" replace />;
    }
  }

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;
